import React from "react";
import { GiFairyWings } from "react-icons/gi"; 
import { Helmet } from "react-helmet-async";
import "./AboutMission.css";

const AboutMission = () => {
  return (
    <>
      <Helmet>
        <title>Our Mission & Vision | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Learn more about our mission and vision at Rajput Shiksha Kosh."
        />
      </Helmet>
    <section className="about-mission-wrapper">
      
      {/* --- CENTER HEADER --- */}
      <div className="about-mission-header">
        <h2 className="about-mission-title">OUR MISSION & VISION</h2>
        <div className="about-mission-divider">
          <span className="about-mission-line"></span>
          <GiFairyWings className="about-mission-icon" />
          <span className="about-mission-line"></span>
        </div>
      </div>

      {/* --- CONTAINER --- */}
      <div className="about-mission-container">

        {/* --- LEFT SIDE: MISSION --- */}
        <div className="about-mission-box">
          <h2>
             Mission
          </h2>
          <p>
            समाज के आर्थिक रूप से असमर्थ प्रतिभावान बालकों की शिक्षा की सुचारू एवं स्थाई व्यवस्था करने हेतु 10 करोड़ का कोष का गठन करना|
          </p>
        </div>

        {/* --- RIGHT SIDE: VISION --- */}
        <div className="about-mission-box">
          <h2>
           Vision
          </h2>
          <p>
            बैंक खातों का विवरण , जिसके ब्याज / लाभांश से अर्थ सहयोग देना |
          </p>
        </div>

      </div>
    </section>
    </>
  );
};

export default AboutMission;